import { Fragment, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Gives a record screen a fresh instance per record.
 *
 * React Router keeps the same component mounted when only a param changes, so
 * moving from one record to another - Back, Forward, J/K, a link in a side
 * panel - would otherwise carry the last record's draft, open panels, scroll
 * and dirty state onto the next one until each effect caught up. On the
 * assignment record that window was long enough for the autosave to write
 * one record's unsaved draft under another's key.
 *
 * Keyed on the one param that names the record, so a tab segment beside it
 * (`/assignments/:id/:tab`) still switches in place.
 */
export function RemountOn({ param, children }: { param: string; children: ReactNode }) {
  const params = useParams();

  return <Fragment key={params[param] ?? ''}>{children}</Fragment>;
}

export default RemountOn;
